import { render, staticRenderFns } from "./ShopAlbigny.vue?vue&type=template&id=fd5f070c&"
import script from "./ShopAlbigny.vue?vue&type=script&lang=js&"
export * from "./ShopAlbigny.vue?vue&type=script&lang=js&"
import style0 from "./ShopAlbigny.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports